import { da, de, enGB, enUS, es, fr, type Locale as DateFnLocale, nb, nl, pl, pt, ptBR, sv } from 'date-fns/locale';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

const getLocale = (languageRegionCode: LanguageRegionCode): DateFnLocale => {
  switch (languageRegionCode) {
    case 'da-DK':
      return da;
    case 'de-DE':
      return de;
    case 'en-GB':
      return enGB;
    case 'es-ES':
    case 'es-MX':
      return es;
    case 'fr-FR':
      return fr;
    case 'it-IT':
      return fr;
    case 'nb-NO':
      return nb;
    case 'nl-NL':
      return nl;
    case 'pl-PL':
      return pl;
    case 'pt-BR':
      return ptBR;
    case 'pt-PT':
      return pt;
    case 'sv-SE':
      return sv;
    case 'en-US':
    default:
      return enUS;
  }
};

export default getLocale;
